import { format, isValid, parseISO, startOfMonth } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { config } from '../config';
import { columnsTranslate, getTimestamp } from '../utils';
import _ from 'lodash';

export default {
	data() {
		return {
			rows: [],
			columns: [],
			columnsPDF: [],
			json_fields: {},
			tableSchema: {},
			isLoading: false,
			cpfCnpj: '',
			initV: 0,
			finalV: 0,
			totalRecords: 0,
			page: 1,
			limit: 10,
			sort: null,
			columnFilters: {},
			selectedRows: [],
			table: {
				columnFilterMap: {}
			},
			dashboardTotalSum: 0
		};
	},
	mounted() {
		const endpointConfig = this.endpoint || { autofetch: true };
		if (endpointConfig.autofetch !== false) {
			this.fetchTableData(true);
		}
	},
	methods: {
		onPerPageChange(params) {
			this.limit = params.currentPerPage;
			this.page = 1;
			this.fetchTableData();
		},
		onSelectAll(params) {
			this.selectedRows = params.selectedRows;
		},
		selectionChanged(params) {
			this.selectedRows = params.selectedRows;
		},
		async reloadItems() {
			this.isLoading = true;
			try {
				await this.fetchTableData();
			} catch (err) {
				console.log(err);
			} finally {
				this.isLoading = false;
			}
		},
		onPageChange(params) {
			this.page = params.currentPage;
			this.fetchTableData();
		},
		onSortChange(params) {
			let { field, type } = params[0];
			field = this.table.columnFilterMap[field] ?? field;

			this.sort = { field, type };
			this.page = 1;
			this.fetchTableData();
		},
		onColumnFilter: _.debounce(function (params) {
			if (params.columnFilters.identity) {
				params.columnFilters.identity = params.columnFilters.identity.replace(
					/\D/g,
					''
				);
			} else if (params.columnFilters.drawee_identity) {
				params.columnFilters.drawee_identity = params.columnFilters.drawee_identity.replace(
					/\D/g,
					''
				);
			} else if (params.columnFilters['receiver_person.cpf_cnpj']) {
				params.columnFilters['receiver_person.cpf_cnpj'] = params.columnFilters['receiver_person.cpf_cnpj'].replace(
					/\D/g,
					''
				);
			} else if (params.columnFilters['person.cpf_cnpj']) {
				params.columnFilters['person.cpf_cnpj'] = params.columnFilters['person.cpf_cnpj'].replace(
					/\D/g,
					''
				);
			}else if (params.columnFilters['person.identity']) {
				params.columnFilters['person.identity'] = params.columnFilters['person.identity'].replace(
					/\D/g,
					''
				);
			} else if (params.columnFilters.cell_phone) {
				params.columnFilters.cell_phone = params.columnFilters.cell_phone.replace(
					/\D/g,
					''
				);
			} else if (params.columnFilters.account) {
				params.columnFilters.account = params.columnFilters.account.replace(
					/\D/g,
					''
				);
			}
			else if (params.columnFilters.account_number) {
				params.columnFilters.account_number = params.columnFilters.account_number.replace(
					/\D/g,
					''
				);
			}
			else if (params.columnFilters.number) {
				params.columnFilters.number = params.columnFilters.number.replace(
					/\D/g,
					''
				);
			}
			else if (params.columnFilters.account_numbers) {
				params.columnFilters.account_numbers = params.columnFilters.account_numbers.replace(
					/\D/g,
					''
				);
			}
			this.columnFilters = params.columnFilters;
			this.page = 1;
			this.fetchTableData();
		}, 1000),

		createURL({ limit = this.limit, page = this.page } = {}) {
			const endpoint = this.endpoint || {};

			if (!endpoint.baseUrl) {
				throw new Error(
					`[Table Mixin] Missing "endpoint" config object at "${this.$options.name}" component`
				);
			}

			const url = endpoint.baseUrl.includes('https://') ? endpoint.baseUrl : `${config.ENDPOINT}${endpoint.baseUrl}`;

			const searchParams = {
				...endpoint.params,
				limit,
				page,
			};

			if (this.sort) {
				if (!searchParams.orders) {
					searchParams.orders = {};
				} else {
					console.log(this.onSortChange.field);
				}

				searchParams.orders[this.sort.field] = this.sort.type;
			}

			if (this.columnFilters && !searchParams.filters) {
				searchParams.filters = [];
			} else {
				if (!searchParams.filters[0]) {
					searchParams.filters = [];
				} else {
					if (Object.keys(this.columnFilters).length > 0) {
						Object.keys(this.columnFilters).forEach(key => {
							searchParams.filters = searchParams.filters.filter(
								fil => fil.field !== key
							);
						});
					}
				}
			}

			Object.keys(this.columnFilters).forEach(key => {
				let value = this.columnFilters[key];
				let operator =
					key === 'identity' ||
					key === 'number' ||
					key === 'cell_phone' ||
					key === 'account' ||
					key === 'id'
					? 'sw'
					: 'lk';
				if (key === 'number_eq') {
					key = 'number'
					operator = 'eq'
				}

				if (!value) {
					return;
				}

				key = this.table.columnFilterMap[key] ?? key;

				searchParams.filters.push({
					field: key,
					operator,
					value,
				});
			});

			if (this.period === 'mes') {
				const start = startOfMonth(new Date());
				searchParams.start_at = start.toISOString();
			}

			if (this.$route.query.detail) {
				searchParams.detail = this.$route.query.detail;
			}

			if (this.$route.query.account_type) {
				searchParams.account_type = this.$route.query.account_type;
			}

			//Colocando timezone em requisições de data
			searchParams.filters.map((item) => {
				if (item.value && (!Number(item.value.toString())) && (Number(item.value) !== 0)) {
					if (((Array.isArray(item.value)) && (isValid(new Date(item.value[0])))) || (isValid(new Date(item.value)))) {
						return item.timezone = getTimestamp();
					}
				}
			});

			return {
				url,
				params: searchParams,
			};
		},
		/* should be called to boostrap the table auto load */
		async fetchTableData() {
			this.isLoading = true;

			try {
				const { url, params } = this.createURL({
					limit: this.limit,
					page: this.page,
				});

				const response = await this.$http.get(url, { params });

				this.dashboardTotalSum = response?.data?.total_sum;
				this.totalRecords = response?.data?.meta?.total ?? 0;
				this.rows = response?.data?.data || {};
				this.columns = this.columns.length > 0 ? this.columns : await this.tableSchemaCreate(this.rows[0]);
				if (window.location.pathname === '/extrato-pix') {
					this.initV = response?.data?.summary?.initial
					this.finalV = response?.data?.summary?.final
				}
				this.isLoading = false;
				if (this.updateCheck) {
					this.updateCheckList();
				}

				this.$vs.loading.close();

				return this.rows;
			} catch (err) {
				console.log(err);
			} finally {
				this.isLoading = false;
				this.$vs.loading.close();
			}
		},
		format(value) {
			try {
				if (!this.hideTime) {
					return format(parseISO(value), 'dd/MM/yyyy HH:mm', {
						locale: ptBR,
					});
				} else {
					return format(parseISO(value), 'dd/MM/yyyy', {
						locale: ptBR,
					});
				}
			} catch (err) {
				return 'data inválida';
			}
		},
		// Construção dinâmica das colunas
		async tableSchemaCreate(schema) {
			if (!schema) {
				return [];
			}
			let keys = Object.keys(schema);
			let resp = [];

			keys.map(key => {

				let label = this.columnConfig[key]?.label || columnsTranslate(key);

				// Campos para a listagem
				resp.push({
					label,
					field: key,
					hidden: this.columnConfig[key]?.hidden || false,
					filterOptions: {
						enabled: this.columnConfig[key]?.filters || false,
						placeholder: `Pesquisar ${label}`,
					},
				});

				// Campos para exportação Excel
				this.json_fields[label] = key;

				// Campos para exportação PDF
				this.columnsPDF.push({
					title: label,
					dataKey: key,
				})

			})
			return resp;
		}
	},
};
